import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { of } from "rxjs";

export const AppRouteGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);

    const appDefaultRoute = 'dashboard';

    if (!route?.fragment) {
        return of(router.parseUrl(appDefaultRoute));
    }

    const fragments = route.fragment.split('?');
    const fragment = fragments[0];
    const params = fragments[1] ? fragments[1].split('&') : [];

    // Redirect known routes to their new locations
    // Safe URL Parameter Characters: Alphanumeric [0-9a-zA-Z], special characters $-_.+!*'()
    const knownRoutes = [
        // Security
        { pattern: /^\/login\/?$/i, redirect: '/sign-in' },
        { pattern: /^\/logout\/?$/i, redirect: '/sign-out' },
        { pattern: /^\/changepassword\/?$/i, redirect: '/reset-password' },
        {
            pattern: /^\/changepassword\/(?<token>[0-9a-f]+)\/(?<username>[\w@%.+'-]+)(\/?)$/i,
            replace: '/reset-password?token=$<token>&username=$<username>'
        },

        // workflow
        {
            pattern: /^\/workflow\-action\/(?<token>[0-9a-f]+)\/?$/i,
            replace: '/workflow-action?token=$<token>'
        },

        // Form Vault
        { pattern: /^\/vault\/?$/i, redirect: '/form-vault' },
        {
            pattern: /^\/vault\/(?<orgSlug>[\w\-.%]+)(\/?)$/i,
            replace: '/form-vault;organisation=$<orgSlug>'
        },
        {
            pattern: /^\/product\/(?<productId>[0-9a-f]{24})(\/?)$/i,
            replace: '/form-vault/$<productId>'
        },

        // Applications
        {
            pattern: /^\/form\/(?<formId>[0-9a-f]{24})(\/app\/(?<appId>[0-9a-f]{24}?))?(\/?)(\?.*)?$/i,
            // No redirect or replace pattern defaults to the original fragment without the hash: '#/'.
        },
        {
            pattern: /^(?:\/form\/(?<formId>[0-9a-f]{24}))(?:\/page\/(?<pageId>\d{1,3}))(?:\/app\/(?<appId>[0-9a-f]{24}))(\/?)$/i,
            replace: '/form/$<formId>/app/$<appId>;page=$<pageId>'
        },
        {
            pattern: /^(?:\/form\/(?<formId>[0-9a-f]{24}))(?:\/page\/(?<pageId>\d{1,3}))(?:\/subpage\/(?<subPageId>\d{1,4}))(?:\/app\/(?<appId>[0-9a-f]{24}))(\/?)$/i,
            replace: '/form/$<formId>/app/$<appId>;page=$<pageId>;subPage=$<subPageId>'
        },
    ];

    for (let knownRoute of knownRoutes) {
        if (knownRoute.pattern.test(fragment))
        {
            let redirect = knownRoute.redirect || route.fragment;
            if (knownRoute.replace) {
                redirect = route.fragment.replace(knownRoute.pattern, knownRoute.replace);
            }

            redirect = redirect.replace(/\/+$/, ''); // trim trailing slashes

            if (params?.length > 0) {
                redirect += '?' + params.join('&');
                // redirect += '?' + Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
            }

            return of(router.parseUrl(redirect));
        }
    }

    return of(router.parseUrl(appDefaultRoute));
    // return of(true)
};
